import {
  CHANGE_ACTIVE_NODE,
  CHANGE_GRAPH,
  REQUEST_DIALOG,
  REQUEST_DIALOG_SUCCESS,
  REQUEST_DIALOG_ERROR,
  UPDATE_DIALOG_SUCCESS,
  UPDATE_DIALOG_ERROR,
  UPDATE_DIALOG,
  ADD_NODE,
  ADD_EDGE,
  UPDATE_NODE,
  UPDATE_EDGE,
  REMOVE_NODE,
  REMOVE_EDGE,
  UPDATE_FEATURE,
  LOAD_PHONENUMBERS,
  UPDATE_PHONENUMBER,
  CHANGE_PHONENUMBER_TO_CONFIGURE,
  RELINK_PHONENUMBER,
  RELINK_PHONENUMBER_SUCCESS,
  RELINK_PHONENUMBER_ERROR,
  CHANGE_ACTIVE_DIALOG_ID,
  ADD_DIALOG,
  REMOVE_DIALOG,
  UNLINK_PHONENUMBER,
  UNLINK_PHONENUMBER_SUCCESS,
  CHANGE_DIALOG_TO_CONFIGURE,
  CHANGE_ACTIVE_DIALOG_REQUESTED,
  CHANGE_DIALOG,
  REMOVE_DIALOG_SUCCESS,
  LOAD_DIALOGS,
  FILTER_DIALOGS,
  FILTER_PHONENUMBERS,
  RELOAD_DIALOGS,
  UPDATE_DIALOG_WARNING,
  REQUEST_VALIDATION_GRAPH_SUCCESS,
  REQUEST_VALIDATION_GRAPH,
  SET_PHONENUMBER_CHANGED,
} from '../actions';
import React from 'react';
import {
  addIncomingOutgoingEdges, setInitialNodeNamesAndSlotNames,
  translateNodesAndEdgesToFeatureFormat,
  mergeNewDialogsAndCustomDialogs,
} from './utils';

const INIT_STATE = {
  activeNode: null,
  activeDialogID: null,
  requestedDialog: null,
  requestingDialog: true,
  sendingDialog: true,
  removingDialog: false,
  error: null,
  dialogs: {},
  phonenumbers: [],
  phonenumberToConfigure: null,
  phonenumberChanged: false,
  dialogToConfigure: null,
  filteredDialogs: null,
  filteredPhonenumbers: null,
  loadingPhonenumbers: false,
  dialogChanged: false,
  reloadDialogs: false,
  validationGraphs: {},
  requestingValidationGraph: true,
};

function structuredClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export default (state = INIT_STATE, action) => {
  const { type, payload } = action;

  state.dialogs = addIncomingOutgoingEdges(state.dialogs);

  switch (type) {
    case CHANGE_ACTIVE_NODE:
      return { ...state, activeNode: payload };

    case CHANGE_ACTIVE_DIALOG_ID:
      if (payload === null || payload === undefined) {
        return {
          ...state,
          activeNode: null,
          activeDialogID: payload,
        };
      }
      return { ...state, activeDialogID: payload };

    case CHANGE_ACTIVE_DIALOG_REQUESTED:
      if (!payload) {
        return {
          ...state,
          requestedDialog: payload,
        };
      }
      const { dialogID, forceShowCurrent, phonenumberChange } = payload;
      return {
        ...state,
        requestedDialog: { dialogID, forceShowCurrent, phonenumberChange },
      };
      // region Dialog

    case LOAD_DIALOGS:
      const dialogs = mergeNewDialogsAndCustomDialogs(state.dialogs, payload);
      return {
        ...state,
        dialogs,
      };

    case RELOAD_DIALOGS:
      return {
        ...state,
        reloadDialogs: true,
      };

    case FILTER_DIALOGS:
      return {
        ...state,
        filteredDialogs: payload,
      };

    case ADD_DIALOG:
      const newDialog = {
        [payload.dialogID]: payload,
      };
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          ...newDialog,
        },
      };

    case UPDATE_DIALOG:
      return {
        ...state,
        sendingDialog: true,
      };

    case UPDATE_DIALOG_SUCCESS:
      const updatedDialogs = {
        ...state.dialogs,
        [payload]: {
          ...state.dialogs[payload],
          graphsCount: state.dialogs[payload].graphsCount + 1,
        },
      };
      return {
        ...state,
        sendingDialog: false,
        dialogChanged: false,
        dialogs: updatedDialogs,
      };

    case UPDATE_DIALOG_WARNING:
      return {
        ...state,
        sendingDialog: false,
        dialogChanged: false,
      };

    case UPDATE_DIALOG_ERROR:
      return {
        ...state,
        error: payload,
      };

    case REMOVE_DIALOG:
      return {
        ...state,
        removingDialog: true,
      };

    case REMOVE_DIALOG_SUCCESS:
      delete state.dialogs[payload];
      return {
        ...state,
        activeDialogID: null,
        dialogToConfigure: {},
        activeNode: null,
        removingDialog: false,
        dialogChanged: false,
      };

    case REQUEST_DIALOG:
      return {
        ...state,
        requestingDialog: true,
      };

    case REQUEST_DIALOG_SUCCESS:
      const [mappedNodes, mappedEdges] = translateNodesAndEdgesToFeatureFormat(
        payload.graph.nodes, payload.graph.edges,
      );
      payload.graph.nodes = mappedNodes;
      payload.graph.edges = mappedEdges;

      payload.graph.nodes = setInitialNodeNamesAndSlotNames(
        payload.graph.nodes,
        payload.dialogID,
        payload.dialogName,
      );

      const requestedDialog = {
        [payload.dialogID]: payload,
      };

      return {
        ...state,
        requestingDialog: false,
        reloadDialogs: false,
        dialogChanged: false,
        dialogs: {
          ...state.dialogs,
          ...requestedDialog,
        },
      };

    case REQUEST_DIALOG_ERROR:
      return {
        ...state,
        error: payload,
        dialogs: {},
      };

    case CHANGE_DIALOG_TO_CONFIGURE:
      return {
        ...state,
        dialogToConfigure: payload,
      };

    case CHANGE_DIALOG:
      state.dialogs[payload.dialogID] = payload;
      console.log(payload);
      return {
        ...state,
        dialogChanged: true,
        dialogs: {
          ...state.dialogs,
        },
      };

      // endregion

      // region Graph
    case CHANGE_GRAPH:
      const { dialogID: graphDialogID, updatedGraph, nodePositionsChanged } = payload;
      const updateGraphDialogs = structuredClone(state.dialogs || {});
      updateGraphDialogs[graphDialogID].graph = {
        ...updatedGraph,
        graphID: updateGraphDialogs[graphDialogID].graph.graphID,
      };
      if (nodePositionsChanged) {
        return {
          ...state,
          dialogs: updateGraphDialogs,
          dialogChanged: true,
        };
      }
      return {
        ...state,
        dialogs: updateGraphDialogs,
      };

    case ADD_NODE:
      const { dialogID: addNodeDialogID, newNode } = payload;
      const addNodeDialogs = structuredClone(state.dialogs || {});
      addNodeDialogs[addNodeDialogID].graph.nodes.push(newNode);
      return {
        ...state,
        dialogChanged: true,
        dialogs: addNodeDialogs,
      };

    case UPDATE_NODE:
      const { dialogID: updateNodeDialogID, updatedNode } = payload;
      const updateNodeDialogs = structuredClone(state.dialogs || {});
      const updateNodeList = updateNodeDialogs[updateNodeDialogID].graph.nodes;
      const updateNodeIndex = updateNodeList.findIndex((e) => e.id === updatedNode.id);
      if (updateNodeIndex >= 0) {
        updateNodeList[updateNodeIndex] = updatedNode;
      }
      updateNodeDialogs[updateNodeDialogID].graph.nodes = updateNodeList;
      return {
        ...state,
        dialogChanged: true,
        dialogs: updateNodeDialogs,
      };

    case REMOVE_NODE:
      const { dialogID: removeNodeDialogID, nodeID: removeNodeID } = payload;
      const removeNodeDialogs = structuredClone(state.dialogs || {});
      let removeNodeList = removeNodeDialogs[removeNodeDialogID].graph.nodes;

      removeNodeList = removeNodeList.filter((e) => e.id !== removeNodeID);
      removeNodeDialogs[removeNodeDialogID].graph.nodes = removeNodeList;

      let removeNodeRemoveEdgeList = removeNodeDialogs[removeNodeDialogID].graph.edges;
      removeNodeRemoveEdgeList = removeNodeRemoveEdgeList.filter(
        (e) => e.target !== removeNodeID && e.source !== removeNodeID,
      );
      removeNodeDialogs[removeNodeDialogID].graph.edges = removeNodeRemoveEdgeList;

      return {
        ...state,
        dialogChanged: true,
        dialogs: removeNodeDialogs,
      };

    case ADD_EDGE:
      const { dialogID: addEdgeDialogID, newEdge } = payload;
      const addEdgeDialogs = structuredClone(state.dialogs || {});
      addEdgeDialogs[addEdgeDialogID].graph.edges.push(newEdge);
      return {
        ...state,
        dialogChanged: true,
        dialogs: addEdgeDialogs,
      };

    case UPDATE_EDGE:
      const { dialogID: updateEdgeDialogID, updatedEdge } = payload;
      const updateEdgeDialogs = structuredClone(state.dialogs || {});
      const updateEdgeList = updateEdgeDialogs[updateEdgeDialogID].graph.edges;
      const updateEdgeIndex = updateEdgeList
        .findIndex((e) => e.id === updatedEdge.id);
      if (updateEdgeIndex >= 0) {
        updateEdgeList[updateEdgeIndex] = updatedEdge;
      }
      updateEdgeDialogs[updateEdgeDialogID].graph.edges = updateEdgeList;
      return {
        ...state,
        dialogChanged: true,
        dialogs: updateEdgeDialogs,
      };

    case REMOVE_EDGE:
      const { dialogID: removeEdgeDialogID, edgeID: removeEdgeID } = payload;
      const removeEdgeDialogs = structuredClone(state.dialogs || {});
      let removeEdgeList = removeEdgeDialogs[removeEdgeDialogID].graph.edges;
      removeEdgeList = removeEdgeList.filter(
        (e) => e.id !== removeEdgeID,
      );
      removeEdgeDialogs[removeEdgeDialogID].graph.edges = removeEdgeList;
      return {
        ...state,
        dialogChanged: true,
        dialogs: removeEdgeDialogs,
      };
      // endregion

      // region Feature
    case UPDATE_FEATURE:
      const {
        dialogID: updateFeatureDialogID, featureID, updatedFeature, updateActiveNode,
      } = payload;
      const updateFeatureDialogs = structuredClone(state.dialogs || {});
      const updateFeatureNodeList = updateFeatureDialogs[updateFeatureDialogID].graph.nodes;
      const updateFeatureNodeIndex = updateFeatureNodeList.findIndex((e) => e.id === featureID);
      if (updateFeatureNodeIndex >= 0) {
        updateFeatureNodeList[updateFeatureNodeIndex].data = updatedFeature;
      }
      updateFeatureDialogs[updateFeatureDialogID].graph.nodes = updateFeatureNodeList;
      const activeFeatureUpdateNode = updateActiveNode
        ? updateFeatureNodeList[updateFeatureNodeIndex]
        : state.activeNode;
      return {
        ...state,
        dialogChanged: true,
        activeNode: activeFeatureUpdateNode,
        dialogs: {
          ...state.dialogs,
          ...updateFeatureDialogs,
        },
      };
      // endregion

      // region Phonenumber
    case LOAD_PHONENUMBERS:
      return {
        ...state,
        phonenumbers: payload,
      };

    case FILTER_PHONENUMBERS:
      return {
        ...state,
        filteredPhonenumbers: payload,
      };

    case UPDATE_PHONENUMBER:
      return {
        ...state,
        phonenumberToConfigure: payload,
      };

    case SET_PHONENUMBER_CHANGED:
      return {
        ...state,
        phonenumberChanged: payload,
      };

    case CHANGE_PHONENUMBER_TO_CONFIGURE:
      return {
        ...state,
        phonenumberToConfigure: payload,
      };

    case RELINK_PHONENUMBER:
      return {
        ...state,
        loadingPhonenumbers: true,
        payload,
      };

    case RELINK_PHONENUMBER_SUCCESS:
      return {
        ...state,
        activeDialogID: payload,
        loadingPhonenumbers: false,
      };

    case RELINK_PHONENUMBER_ERROR:
      return {
        ...state,
        phonenumbers: [...state.phonenumbers],
        loadingPhonenumbers: false,
      };

    case UNLINK_PHONENUMBER:
      if (payload.dialogID === state.activeDialogID) {
        return {
          ...state,
          phonenumbers: [...state.phonenumbers],
          phonenumberToConfigure: null,
          loadingPhonenumbers: true,
          activeDialogID: null,
          dialogToConfigure: {},
          activeNode: null,
        };
      }
      return {
        ...state,
        phonenumbers: [...state.phonenumbers],
        phonenumberToConfigure: null,
        loadingPhonenumbers: true,
      };

    case UNLINK_PHONENUMBER_SUCCESS:
      return {
        ...state,
        loadingPhonenumbers: false,
      };
      // endregion

      // region validation
    case REQUEST_VALIDATION_GRAPH:
      return {
        ...state,
        requestingValidationGraph: true,
      };

    case REQUEST_VALIDATION_GRAPH_SUCCESS:
      const { dialogID: validationDialogID, validationGraph } = payload;
      return {
        ...state,
        validationGraphs: {
          ...state.validationGraphs,
          [validationDialogID]: validationGraph,
        },
        requestingValidationGraph: false,
      };
      // endregion

    default: return { ...state };
  }
};
